import { SummaryCard } from "@certn/cascadia-react";
import {
  CascadiaJsonFormContext,
  CascadiaLayoutProps,
  withCascadiaLayoutProps,
} from "@certn/forms";
import { BaseLayout } from "@certn/forms/src/layouts/BaseLayout";
import { BaseLayoutContent } from "@certn/forms/src/layouts/BaseLayoutContent";
import { slugify } from "@certn/utils";
import { useContext } from "react";

import { ApplicationContext } from "../ApplicationContext";
import { useApplicationFormContext } from "../ApplicationFormContext";
import { QuickscreenConsentBaseLayout } from "./QuickscreenConsentBaseLayout";
import { SummaryEditLink } from "./SummaryEditLink";

/**
 * Quickscreen consent step for a single regional check (download, upload, confirm).
 * One JsonForms layout type per check so client portal can specialize copy and QA hooks later.
 */
export function QuickscreenRegionalConsentLayout(props: CascadiaLayoutProps) {
  const { isSummary, readonly } = useContext(CascadiaJsonFormContext);
  const { caseId } = useApplicationFormContext();
  const { basePath = "quickscreen" } = useContext(ApplicationContext) || {};

  if (isSummary) {
    const uischema = props.uischema as typeof props.uischema & {
      label?: string;
      name?: string;
    };
    const sectionName = uischema.name;
    return (
      <SummaryCard
        header={uischema.label}
        testID="quickscreen-regional-consent-layout-summary"
        actions={
          !readonly &&
          sectionName && (
            <SummaryEditLink
              href={`/${basePath}/${caseId}/${slugify(sectionName)}`}
              testID="quickscreen-regional-consent-summary-edit-button"
            />
          )
        }
      >
        <BaseLayout {...props}>
          <BaseLayoutContent />
        </BaseLayout>
      </SummaryCard>
    );
  }

  return (
    <QuickscreenConsentBaseLayout
      layoutProps={props}
      testID="quickscreen-regional-consent-layout"
    />
  );
}

QuickscreenRegionalConsentLayout.displayName =
  "QuickscreenRegionalConsentLayout";

export const QuickscreenRegionalConsentLayoutRenderer = withCascadiaLayoutProps(
  QuickscreenRegionalConsentLayout
);
